/**
 * Emite notificaciones toast independientes llamando directamente al $toast provisto.
 * 
 * @param {Object} toast - Instancia de toast (pásale `this.$toast`)
 * @param {Object|string} data - Objeto de la API o string
 * @param {('success'|'warning'|'error')} [tipo='error'] - Tipo de toast
 * @param {string} [tituloCustom] - Título opcional
 */
export const notificar = (toast, data, tipo = 'error', tituloCustom = '') => {
  // Validar que se reciba $toast y que el método especificado exista
  if (!toast || typeof toast[tipo] !== 'function') {
    console.error(`El objeto toast provisto no tiene el método .${tipo}()`);
    return;
  }

  const titulos = {
    success: 'Éxito',
    warning: 'Advertencia',
    error: 'Error'
  };

  const titulo = tituloCustom || titulos[tipo] || 'Notificación';
  const opciones = { position: 'topRight' };

  // Helper interno
  const emitir = (mensaje) => {
    toast[tipo](mensaje, titulo, opciones);
  };

  // 1. Si es un texto simple
  if (typeof data === 'string') {
    emitir(data);
    return;
  }

  // 2. Si es un objeto de la API (ej: { detail: "Respuesta" } o { email: ['Obligatorio'] })
  if (data && typeof data === 'object') {
    const campos = Object.keys(data);

    if (campos.length === 0) {
      emitir('Procesado correctamente.');
      return;
    }

    campos.forEach(campo => {
      const datosDelCampo = data[campo];
      
      // Omitir el nombre de la clave si es genérica como 'detail' o 'message'
      const esCampoGenerico = ['detail', 'message', 'error', 'msg'].includes(campo.toLowerCase());
      const nombreCampo = campo.charAt(0).toUpperCase() + campo.slice(1).replace(/_/g, ' ');

      // Si el campo trae una lista de mensajes
      if (Array.isArray(datosDelCampo)) {
        datosDelCampo.forEach(mensaje => {
          const texto = esCampoGenerico ? mensaje : `${nombreCampo}: ${mensaje}`;
          emitir(texto);
        });
      } else {
        // Si es un valor simple
        const texto = esCampoGenerico ? datosDelCampo : `${nombreCampo}: ${datosDelCampo}`;
        emitir(texto);
      }
    });
    return;
  }

  // 3. Fallback genérico
  emitir('Ha ocurrido un evento al procesar la solicitud.');
};

// --- Atajos pasándole `this.$toast` ---

export const notificarExito = (toast, data, titulo = 'Éxito') => 
  notificar(toast, data, 'success', titulo);

export const notificarAdvertencia = (toast, data, titulo = 'Advertencia') => 
  notificar(toast, data, 'warning', titulo);

export const notificarError = (toast, data, titulo = 'Error') => 
  notificar(toast, data, 'error', titulo);